const populateRememberMe = (email) => {
  const keepMeSignedInEmail = localStorage.getItem('rememberMe');
  if (email && (!keepMeSignedInEmail || ['null', 'undefined'].includes(keepMeSignedInEmail))) {
    localStorage.setItem('rememberMe', email);
  }
};

export default populateRememberMe;
